import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7530f604"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pay-channel-card" }
const _hoisted_2 = { class: "pay-channel-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "支付通道管理", -1))
const _hoisted_4 = {
  key: 0,
  class: "pay-mode-notice warning"
}
const _hoisted_5 = { class: "notice-icon" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("当前小店为"),
  /*#__PURE__*/_createElementVNode("strong", null, "自定义支付通道"),
  /*#__PURE__*/_createTextVNode("，游客访问小店后，将使用您自定义的支付通道进行支付，请确保余额充足，否则即使支付成功，余额支付开通授权时也会失败。 ")
], -1))
const _hoisted_7 = {
  key: 1,
  class: "pay-mode-notice info"
}
const _hoisted_8 = { class: "notice-icon" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("当前小店为"),
  /*#__PURE__*/_createElementVNode("strong", null, "系统支付通道"),
  /*#__PURE__*/_createTextVNode("，游客访问小店后，将使用系统支付通道进行支付，您自定义的支付通道不会生效，游客支付授权成功后，将发放反利给您。 ")
], -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }

import { ref, onMounted } from 'vue'
import axios from 'axios'
import { message, Modal } from 'ant-design-vue'
import { WarningOutlined, InfoCircleOutlined } from '@ant-design/icons-vue'
import UserHead from '@/components/UserHead.vue'
import UserHeadTop from '@/components/UserHeadTop.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PayChannelView',
  setup(__props) {

const baseURL = process.env.VUE_APP_API_BASE_URL
const headers = { 'token': localStorage.getItem('token') || '' }

const channelList = ref<any[]>([])
const loading = ref(false)
const dialogVisible = ref(false)
const isEdit = ref(false)
const submitting = ref(false)
const orderPayMode = ref('')

const channelForm = ref<any>({
    id: 0,
    name: '',
    platform: 1,
    type: '',
    config: '',
    state: 1,
})

// 用于编辑/新增时的配置对象
const channelConfig = ref<Record<string, any>>({})

// 易支付时多选的支付类型
const selectedTypes = ref<string[]>([])

// 表格列定义
const columns = [
    { title: '通道名称', key: 'name', dataIndex: 'name' },
    { title: '支付平台', key: 'platform', width: 100 },
    { title: '支付类型', key: 'type', width: 130 },
    { title: '支付方式', key: 'payMethod', width: 130 },
    { title: '配置信息', key: 'config', ellipsis: true },
    { title: '状态', key: 'state', width: 80 },
    { title: '操作', key: 'action', width: 150, fixed: 'right' },
]

// platform映射：1=易支付，2=支付宝
const formatPlatform = (p: any) => {
    const map: Record<number, string> = { 1: '易支付', 2: '支付宝' }
    return map[p] || '未知'
}

// 解析type为数组（兼容数组、JSON字符串、旧格式如"['alipay']"）
const parseType = (t: any): string[] => {
    if (!t) return []
    if (Array.isArray(t)) return t
    try {
        const parsed = JSON.parse(t)
        if (Array.isArray(parsed)) return parsed
    } catch {
        // 旧格式如 "['alipay']" 不是合法JSON，尝试用正则提取
        const matches = String(t).match(/'([^']+)'/g)
        if (matches) return matches.map(m => m.replace(/'/g, ''))
    }
    return [String(t)]
}

// type映射（支持数组和字符串）
const formatType = (t: any) => {
    if (!t) return '-'
    const typeMap: Record<string, string> = { wxpay: '微信支付', alipay: '支付宝', qqpay: 'QQ支付', usdt: 'USDT' }
    const arr = parseType(t)
    if (arr.length === 0) return '-'
    return arr.map(item => typeMap[item] || item).join('、')
}

// 支付方式：根据platform和config.product_code判断
const formatPayMethod = (row: any) => {
    if (row.platform === 1) return '易支付(跳转)'
    if (row.platform === 2) {
        try {
            const config = typeof row.config === 'string' ? JSON.parse(row.config) : row.config
            if (config.product_code === 'FAST_INSTANT_TRADE_PAY') return '网站支付(跳转)'
            return '当面付(扫码)'
        } catch {
            return '当面付(扫码)'
        }
    }
    return '-'
}

// 编辑时实际使用的通道类型（仅UI使用）
const editType = ref('yipay')

// 根据row数据推断editType
const detectEditType = (row: any): string => {
    if (row.platform === 2) {
        const config = parseConfig(row.config)
        if (config.product_code === 'FAST_INSTANT_TRADE_PAY') return 'alipay_web'
        return 'alipay_dmf'
    }
    return 'yipay'
}

// 切换支付平台时清理无关配置
const onPlatformChange = (newType: string) => {
    if (newType === 'yipay') {
        // 切到易支付，保留易支付字段，清理支付宝字段
        const kept: Record<string, any> = {}
        if (channelConfig.value.url) kept.url = channelConfig.value.url
        if (channelConfig.value.pid) kept.pid = channelConfig.value.pid
        if (channelConfig.value.key) kept.key = channelConfig.value.key
        channelConfig.value = kept
        channelForm.value.platform = 1
    } else if (newType === 'alipay_dmf') {
        // 切到当面付，保留支付宝字段，设置产品码
        const kept: Record<string, any> = {}
        if (channelConfig.value.app_id) kept.app_id = channelConfig.value.app_id
        if (channelConfig.value.public_key) kept.public_key = channelConfig.value.public_key
        if (channelConfig.value.private_key) kept.private_key = channelConfig.value.private_key
        kept.product_code = 'FACE_TO_FACE_PAYMENT'
        channelConfig.value = kept
        channelForm.value.platform = 2
        selectedTypes.value = []
    } else if (newType === 'alipay_web') {
        // 切到网站支付，保留支付宝字段，设置产品码
        const kept: Record<string, any> = {}
        if (channelConfig.value.app_id) kept.app_id = channelConfig.value.app_id
        if (channelConfig.value.public_key) kept.public_key = channelConfig.value.public_key
        if (channelConfig.value.private_key) kept.private_key = channelConfig.value.private_key
        kept.product_code = 'FAST_INSTANT_TRADE_PAY'
        channelConfig.value = kept
        channelForm.value.platform = 2
        selectedTypes.value = []
    }
}

// 配置摘要
const configSummary = (configStr: any) => {
    if (!configStr) return '-'
    try {
        const obj = typeof configStr === 'string' ? JSON.parse(configStr) : configStr
        const keys = Object.keys(obj)
        if (keys.length === 0) return '-'
        return keys.map(k => `${k}=${obj[k]}`).join(', ')
    } catch {
        return String(configStr)
    }
}

// 将 config 字符串解析为编辑用的对象
const parseConfig = (configStr: any): Record<string, any> => {
    if (!configStr) return {}
    try {
        return typeof configStr === 'string' ? JSON.parse(configStr) : { ...configStr }
    } catch {
        return {}
    }
}

// 将配置对象序列化为字符串
const stringifyConfig = (obj: Record<string, any>): string => {
    return JSON.stringify(obj)
}

const getChannelList = async () => {
    loading.value = true
    try {
        const res = await axios.post(baseURL + '/api/shop/tenant/payChannels', {}, { headers })
        if (res.data.code === 0) {
            const data = res.data.data
            // 新结构：{ list, order_pay_mode }
            if (data && data.list) {
                channelList.value = data.list
                orderPayMode.value = data.order_pay_mode || ''
            } else if (Array.isArray(data)) {
                // 兼容旧结构
                channelList.value = data
                orderPayMode.value = res.data.order_pay_mode || ''
            } else {
                channelList.value = []
            }
        } else {
            message.error(res.data.msg || '获取支付通道失败')
        }
    } catch (e: any) {
        message.error('获取支付通道失败：' + e.message)
    } finally {
        loading.value = false
    }
}

const openAddDialog = () => {
    isEdit.value = false
    channelForm.value = { id: 0, name: '', platform: 1, type: [], config: '', state: 1 }
    editType.value = 'yipay'
    channelConfig.value = {}
    selectedTypes.value = []
    dialogVisible.value = true
}

const openEditDialog = (row: any) => {
    isEdit.value = true
    channelForm.value = { ...row }
    channelConfig.value = parseConfig(row.config)
    editType.value = detectEditType(row)
    // 易支付时初始化多选支付类型
    if (editType.value === 'yipay') {
        selectedTypes.value = parseType(row.type)
    } else {
        selectedTypes.value = []
    }
    dialogVisible.value = true
}

const submitChannel = async () => {
    // 同步platform和type
    if (editType.value === 'yipay') {
        channelForm.value.platform = 1
        if (selectedTypes.value.length === 0) {
            message.warning('请选择支付类型')
            return
        }
        channelForm.value.type = selectedTypes.value
    } else if (editType.value === 'alipay_dmf') {
        channelForm.value.platform = 2
        channelForm.value.type = ['alipay']
        channelConfig.value.product_code = 'FACE_TO_FACE_PAYMENT'
    } else if (editType.value === 'alipay_web') {
        channelForm.value.platform = 2
        channelForm.value.type = ['alipay']
        channelConfig.value.product_code = 'FAST_INSTANT_TRADE_PAY'
    }
    // 校验配置必填项
    const configValues = Object.values(channelConfig.value).filter(v => v !== undefined && v !== '')
    if (configValues.length === 0) {
        message.warning('请填写通道配置信息')
        return
    }
    submitting.value = true
    try {
        const url = isEdit.value ? '/api/shop/tenant/payChannel/update' : '/api/shop/tenant/payChannel/add'
        const payload = {
            ...channelForm.value,
            type: JSON.stringify(channelForm.value.type),
            config: stringifyConfig(channelConfig.value),
        }
        const res = await axios.post(baseURL + url, payload, { headers })
        if (res.data.code === 0) {
            message.success(isEdit.value ? '修改成功' : '添加成功')
            dialogVisible.value = false
            getChannelList()
        } else {
            message.error(res.data.msg || '操作失败')
        }
    } catch (e: any) {
        message.error('操作失败：' + e.message)
    } finally {
        submitting.value = false
    }
}

const deleteChannel = (row: any) => {
    Modal.confirm({
        title: '提示',
        content: `确认删除支付通道「${row.name || formatPlatform(row.platform)}」吗？`,
        okText: '确认删除',
        cancelText: '取消',
        okButtonProps: { danger: true },
        onOk: async () => {
            try {
                const res = await axios.post(baseURL + '/api/shop/tenant/payChannel/delete', { id: row.id }, { headers })
                if (res.data.code === 0) {
                    message.success('删除成功')
                    getChannelList()
                } else {
                    message.error(res.data.msg || '删除失败')
                }
            } catch (e: any) {
                message.error('删除失败：' + e.message)
            }
        },
    })
}

onMounted(() => {
    getChannelList()
})

return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"min-height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(UserHead),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, { style: {"padding":"0","background":"#fff","border-bottom":"1px solid #f0f0f0"} }, {
            default: _withCtx(() => [
              _createVNode(UserHeadTop)
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, { class: "pay-channel-content-div" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: openAddDialog
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增通道")
                    ]),
                    _: 1
                  })
                ]),
                (orderPayMode.value === 'tenant')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_unref(WarningOutlined))
                      ]),
                      _hoisted_6
                    ]))
                  : (orderPayMode.value === 'system')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_unref(InfoCircleOutlined))
                        ]),
                        _hoisted_9
                      ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_a_table, {
                  "data-source": channelList.value,
                  columns: columns,
                  loading: loading.value,
                  pagination: false,
                  "row-key": "id",
                  class: "pay-channel-table",
                  size: "middle"
                }, {
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.key === 'name')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(record.name || formatPlatform(record.platform)), 1))
                      : (column.key === 'platform')
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            color: "blue",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(formatPlatform(record.platform)), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (column.key === 'type')
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 2,
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(formatType(record.type)), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (column.key === 'payMethod')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(formatPayMethod(record)), 1))
                            : (column.key === 'config')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(configSummary(record.config)), 1))
                              : (column.key === 'state')
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 5,
                                    color: record.state === 1 ? 'success' : 'default',
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(record.state === 1 ? '启用' : '禁用'), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                                : (column.key === 'action')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                      _createVNode(_component_a_button, {
                                        size: "small",
                                        onClick: ($event: any) => (openEditDialog(record))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("编辑")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_a_button, {
                                        size: "small",
                                        danger: "",
                                        onClick: ($event: any) => (deleteChannel(record))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("删除")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ], 64))
                                  : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["data-source", "loading"])
              ]),
              _createVNode(_component_a_modal, {
                open: dialogVisible.value,
                "onUpdate:open": _cache[14] || (_cache[14] = ($event: any) => ((dialogVisible).value = $event)),
                title: isEdit.value ? '编辑支付通道' : '新增支付通道',
                width: "560px",
                "mask-closable": false,
                footer: null
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (dialogVisible.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("取消")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: submitChannel,
                    loading: submitting.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("确认")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_form, {
                    model: channelForm.value,
                    layout: "vertical"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "通道名称" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: channelForm.value.name,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((channelForm.value.name) = $event)),
                            placeholder: "如：支付宝通道（留空则显示平台名）"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "支付平台",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: editType.value,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editType).value = $event)),
                            placeholder: "选择支付平台",
                            onChange: onPlatformChange
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: "yipay" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("易支付")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: "alipay_dmf" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("支付宝当面付")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: "alipay_web" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("支付宝网站支付")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      (editType.value === 'yipay')
                        ? (_openBlock(), _createBlock(_component_a_form_item, {
                            key: 0,
                            label: "支付类型",
                            required: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                value: selectedTypes.value,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((selectedTypes).value = $event)),
                                mode: "multiple",
                                placeholder: "选择支持的支付类型（可多选）"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select_option, { value: "wxpay" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("微信支付")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_select_option, { value: "alipay" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("支付宝")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_select_option, { value: "qqpay" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("QQ支付")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_select_option, { value: "usdt" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("USDT")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (editType.value === 'yipay')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_a_form_item, {
                              label: "接口URL",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: channelConfig.value.url,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((channelConfig.value.url) = $event)),
                                  placeholder: "https://pay.example.com"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, {
                              label: "商户PID",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: channelConfig.value.pid,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((channelConfig.value.pid) = $event)),
                                  placeholder: "易支付商户ID"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, {
                              label: "商户KEY",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input_password, {
                                  value: channelConfig.value.key,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((channelConfig.value.key) = $event)),
                                  placeholder: "易支付商户密钥"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ], 64))
                        : (editType.value === 'alipay_dmf')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createVNode(_component_a_form_item, {
                                label: "AppID",
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: channelConfig.value.app_id,
                                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((channelConfig.value.app_id) = $event)),
                                    placeholder: "支付宝应用ID"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "公钥",
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_textarea, {
                                    value: channelConfig.value.public_key,
                                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((channelConfig.value.public_key) = $event)),
                                    rows: 3,
                                    placeholder: "支付宝公钥"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_form_item, {
                                label: "私钥",
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_textarea, {
                                    value: channelConfig.value.private_key,
                                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((channelConfig.value.private_key) = $event)),
                                    rows: 3,
                                    placeholder: "应用私钥"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ], 64))
                          : (editType.value === 'alipay_web')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createVNode(_component_a_form_item, {
                                  label: "AppID",
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: channelConfig.value.app_id,
                                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((channelConfig.value.app_id) = $event)),
                                      placeholder: "支付宝应用ID"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_form_item, {
                                  label: "公钥",
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_textarea, {
                                      value: channelConfig.value.public_key,
                                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((channelConfig.value.public_key) = $event)),
                                      rows: 3,
                                      placeholder: "支付宝公钥"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_form_item, {
                                  label: "私钥",
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_textarea, {
                                      value: channelConfig.value.private_key,
                                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((channelConfig.value.private_key) = $event)),
                                      rows: 3,
                                      placeholder: "应用私钥"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ], 64))
                            : _createCommentVNode("", true),
                      _createVNode(_component_a_form_item, { label: "状态" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_switch, {
                            checked: channelForm.value.state,
                            "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((channelForm.value.state) = $event)),
                            "checked-value": 1,
                            "un-checked-value": 2,
                            "checked-children": "启用",
                            "un-checked-children": "禁用"
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]),
                _: 1
              }, 8, ["open", "title"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})